import { bindingMode } from 'aurelia-framework';
import { autoinject, bindable, customElement } from 'aurelia-framework';

import { FormModel } from '~/models/form-model';
import { Logger } from '~/utils/logger';

export enum FormType {
	DEFAULT = 'DEFAULT',
	ADD = 'ADD',
	EDIT = 'EDIT',
}

@autoinject
@customElement('a-form')
export class Form {
	/**
	 * Type of form
	 */
	public static readonly TYPE = FormType;

	/**
	 * formModel is currently leveraged by "search.ts" to do filtering based on the values
	 * of other fields.
	 *
	 * @deprecated Avoid using this for new features. If your field needs formModel, pass it
	 * in directly. For customisations, we will need to update our customisation rendering
	 * code to apply a "form-model.bind" attribute to fields that need it before we parse/execute
	 * the customisation HTML.
	 */
	@bindable({
		defaultBindingMode: bindingMode.toView,
	})
	public readonly formModel: FormModel;

	/**
	 * parentId is leveraged by legacy "field.ts" code to build a unique ID for the field
	 * based on this forms ID.
	 *
	 * @deprecated Avoid using this for new features.
	 */
	@bindable public readonly parentId: string;

	/**
	 * Form type which determines the behavior of the whole form
	 */
	@bindable private readonly formType: FormType = FormType.DEFAULT;

	constructor(private element: Element) {}
}
